// Downloads a file from S3 using Amplify Storage and triggers a browser download.

import { getUrl } from "@aws-amplify/storage";

interface DownloadS3FileParams {
	bucketKey: string;
	path: string;
	fileName: string;
	contentType: string;
}

export async function downloadS3File(params: DownloadS3FileParams): Promise<void> {
	const { path, fileName, contentType } = params;

	// Get a presigned URL for the S3 object
	const result = await getUrl({
		path: path,
		options: {
			validateObjectExistence: true,
			expiresIn: 300,
		},
	});

	// Fetch the file content
	const response = await fetch(result.url.toString());
	if (!response.ok) {
		throw new Error(`Failed to download file: ${response.statusText}`);
	}
	const blob = await response.blob();

	// Trigger browser download
	const url = URL.createObjectURL(new Blob([blob], { type: contentType }));
	const link = document.createElement("a");
	link.href = url;
	link.download = fileName;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	setTimeout(() => URL.revokeObjectURL(url), 100);
}
